// extracted by mini-css-extract-plugin
export var gatewaySwitcher = "HeaderGateway-module--gatewaySwitcher--5-Cj2";
export var gatewaySwitcherButton = "HeaderGateway-module--gatewaySwitcherButton--1YXMa";
export var activeLink = "HeaderGateway-module--activeLink--3LPrf";